import { isFilled } from './model';

// Generates the spec's "פסקת תיאור מצב קיים" — a verbal summary with automatic
// disclaimers keyed to the data's source/status (no interior survey, building-
// file OCR, etc.). Editable afterwards; regenerated on demand.
export function buildExistingDescription(project) {
  const s = project.existingState.summary;
  const raw = project.existingState.builtAsRaw;
  const permits = project.permitTimeline || [];
  const parts = [];

  const bits = [];
  if (isFilled(s.builtArea)) bits.push(`שטח בנוי כ-${s.builtArea.value} מ"ר`);
  if (isFilled(s.units)) bits.push(`כ-${s.units.value} יחידות דיור`);
  if (isFilled(s.rooms)) bits.push(`${s.rooms.value} חדרים`);
  if (isFilled(s.storiesAbove)) bits.push(`${s.storiesAbove.value} קומות מעל הכניסה הקובעת`);

  if (bits.length) parts.push(`הנכס כולל בניין קיים (${bits.join(', ')}).`);
  else parts.push('טרם הוזנו נתוני מצב קיים מובנים לנכס.');

  if (raw && raw.building_file_evidence) {
    parts.push('הנתונים חולצו אוטומטית ממסמך סרוק בתיק הבניין (פרוטוקול ביקורת בגמר הבנייה) וטרם אומתו מול מדידת פנים — יש לאמת מול המסמך הסרוק לפני קבלת החלטה תכנונית או כלכלית.');
  } else if (raw && raw.built_as) {
    parts.push('הנתונים מבוססים על רשומת טופס 4 מובנית במאגר.');
  } else {
    parts.push('החישוב מתבסס על נתוני היתרים ומסמכים קיימים ולא על מדידת פנים עדכנית.');
  }

  if (permits.length) parts.push(`נמצאו ${permits.length} היתרים/בקשות הקשורים לנכס לפי מיקומו.`);
  parts.push('יש לבדוק הפקעות, זיקות הנאה וקווי בניין לפי מדידה ותכניות חלות.');

  return parts.join(' ');
}
